import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { AppRoutingModule } from './app-routing.module';
import { Globals } from './globals';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';   //npm install --save ngx-mask
import { DataTablesModule} from 'angular-datatables';

/*Importación para Culture Español*/
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { RegistroComponent } from './components/admin/registro/registro.component';
import { HomeComponent } from './components/admin/home/home.component';
import { AvisoPrivacidadComponent } from './components/negocio/aviso-privacidad/aviso-privacidad.component';
import { RegistroUsuariosComponent } from './components/admin/registro-usuarios/registro-usuarios.component';
import { RegistroDocsarchComponent } from './components/admin/registro-docsarch/registro-docsarch.component';
import { PrincipalComponent } from './components/negocio/principal/principal.component';
import { AdquisicionesComponent } from './components/negocio/adquisiciones/adquisiciones.component';
import { RestablecerComponent } from './components/admin/restablecer/restablecer.component';
import { RestablecerContrasenaComponent } from './components/admin/restablecer-contrasena/restablecer-contrasena.component';
import { ProcedimientosComponent } from './components/negocio/procedimientos/procedimientos.component';
import { ProcedimientosDetalleComponent } from './components/negocio/procedimientos-detalle/procedimientos-detalle.component';
import { ProcsComponent } from './components/negocio/participa/procedimientos/procs.component';
import { InfoGralProductoComponent } from './components/negocio/participa/flujo-producto/infoGral-producto/infoGral-producto.component';
import { DateLongPipe } from './pipes/date-long.pipe';
import { CountDownComponent } from './components/generales/count-down/count-down.component';
import { OrdenCompraProductoComponent } from './components/negocio/participa/flujo-producto/ordenCompra-producto/ordenCompra-producto.component';
import { SubirCotizacionProductoComponent } from './components/negocio/participa/flujo-producto/subirCotizacion-producto/subirCotizacion-producto.component';
import { MenuProductoComponent } from './components/negocio/participa/flujo-producto/menu-producto/menu-producto.component';
import { AvisoPrivLogComponent } from './components/negocio/aviso-priv-log/aviso-priv-log.component';
import { MenuObraComponent } from './components/negocio/participa/flujo-obra/menu-obra/menu-obra.component';
import { InfoGralObraComponent } from './components/negocio/participa/flujo-obra/info-gral-obra/info-gral-obra.component';
import { PlazofecObraComponent } from './components/negocio/participa/flujo-obra/plazofec-obra/plazofec-obra.component';
import { SubirPropuestaObraComponent } from './components/negocio/participa/flujo-obra/subir-propuesta-obra/subir-propuesta-obra.component';
import { MenuPerfilComponent } from './components/admin/menu-perfil/menu-perfil.component';
import { VerificarComponent } from './components/admin/verificar/verificar.component';
import { PropuestaObraComponent } from './components/negocio/participa/flujo-obra/propuesta-obra/propuesta-obra.component';
import { ProcedimientosDetObraComponent } from './components/negocio/procedimientos-det-obra/procedimientos-det-obra.component';
import { ReenviarCorreoComponent } from './components/admin/reenviar-correo/reenviar-correo.component';
import { FiltroItemsPipe } from './pipes/filtro-items.pipe';
import { PadronProveedoresComponent } from './components/negocio/padron-proveedores/padron-proveedores.component';

registerLocaleData(localeEs, 'es');

const globalSettings: RecaptchaSettings = { siteKey: '6Ld-KrQUAAAAAIq5oj4Gs6HPJG4sTWMdpR5tdVIp' };

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    RegistroComponent,
    HomeComponent,
    AvisoPrivacidadComponent,
    RegistroUsuariosComponent,
    RegistroDocsarchComponent,
    PrincipalComponent,
    AdquisicionesComponent,
    RestablecerComponent,
    RestablecerContrasenaComponent,
    ProcedimientosComponent,
    ProcedimientosDetalleComponent,
    ProcsComponent,
    InfoGralProductoComponent,
    DateLongPipe,
    CountDownComponent,
    MenuProductoComponent,
    OrdenCompraProductoComponent,
    SubirCotizacionProductoComponent,
    AvisoPrivLogComponent,
    MenuObraComponent,
    InfoGralObraComponent,
    PlazofecObraComponent,
    SubirPropuestaObraComponent,
    MenuPerfilComponent,
    VerificarComponent,
    PropuestaObraComponent,
    ProcedimientosDetObraComponent,
    ReenviarCorreoComponent,
    FiltroItemsPipe,
    PadronProveedoresComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    NgxMaskModule.forRoot()
   ,DataTablesModule
  ],
  providers: [Globals,
              {
                provide: RECAPTCHA_SETTINGS,
                useValue: globalSettings,
              },
              [ { provide: localeEs, useValue: 'es' } ],
            ],
  bootstrap: [AppComponent]
})
export class AppModule { }
